'use client'

import React from 'react'
import TransportandLogisticsComponent from './TransportandLogisticsComponent'
import CompanyDetailCard from '../../../components/(MiniWebsite)/CompanyDetailCard'
import { usePathname } from 'next/navigation'
import useScreenSize from '@/app/hooks/useScreenSize'

const TransportandLogisticsPage = ({
  tab,
  id,
}: {
  tab: React.ReactNode
  id: string
}) => {
  const pathName = usePathname()
  const screenSize = useScreenSize()
  return (
    <div>
      <TransportandLogisticsComponent />
      <div className="flex mobile:flex-col">
        <div>
          {(screenSize.width >= 768 ||
            pathName.split('/')[pathName.split('/').length - 1] ===
              'profile') && (
            <CompanyDetailCard
              id={id}
              companyIndustryType="transport_logistics"
            />
          )}
        </div>
        <div className="pl-9 pt-5 w-full mobile-width mobile:pl-0">{tab}</div>
      </div>
    </div>
  )
}

export default TransportandLogisticsPage
